import React, { useState } from "react";

const DemandesContext = React.createContext({
  demandes: [],
  defaultDemandes: [],
  areDemandesLoaded: false,
  filterDemandes: (filterDemandesMethod) => {},
  persistDefaultDemandes: (defaultDemandes) => {},
  reloadDemandes: () => {},
});

export const DemandesContextProvider = (props) => {
  const [demandes, setDemandes] = useState([]);
  const [defaultDemandes, setDefaultDemandes] = useState([]);
  const [areDemandesLoaded, setAreDemandesLoaded] = useState(false);

  const defaultDemandesHandler = (defaultDemandes) => {
    setDefaultDemandes(defaultDemandes);
    setAreDemandesLoaded(true);
  };

  const filterDemandesHandler = (filterDemandesMethod) => {
    setDemandes(filterDemandesMethod(defaultDemandes));
  };

  const reloadDemandes = () => {
    setAreDemandesLoaded(false);
  };

  const contextValue = {
    demandes: demandes,
    defaultDemandes: defaultDemandes,
    areDemandesLoaded: areDemandesLoaded,
    filterDemandes: filterDemandesHandler,
    persistDefaultDemandes: defaultDemandesHandler,
    reloadDemandes: reloadDemandes,
  };

  return (
    <DemandesContext.Provider value={contextValue}>
      {props.children}
    </DemandesContext.Provider>
  );
};

export default DemandesContext;
